
            const data = {"name":"plus","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M24 10H14V0h-4v10H0v4h10v10h4V14h10z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                